import { dataLayerPublish } from '@dhl/datalayer'
import { post } from '~/util/api/post'

export type PromocodeResult = {
  percentage: number
  carrier: string | null
  originCountries: string[]
  destinationCountries: string[]
  maxUses: number
}

export const fetchPromocode = async (key: string): Promise<PromocodeResult> => {
  const { discount, carriers, fromCountries, toCountries, maxUses } = await post('/api/promocode/check', {
    key,
  })

  const carrier = (() => {
    switch (carriers.length) {
      case 0:
        return null
      case 1:
        return carriers[0]
      default:
        dataLayerPublish('EVENT', {
          id: 'fetchPromocode',
          message: `Warning: multiple carriers found for promotion key ${key}. Only restrict a promotion key to at most one carrier.`,
        })
        return null
    }
  })()

  return {
    percentage: discount,
    carrier,
    originCountries: fromCountries,
    destinationCountries: toCountries,
    maxUses,
  }
}
